import { render } from "./ModalAddEmployee.vue?vue&type=template&id=4a7c24b8"
import script from "./ModalAddEmployee.vue?vue&type=script&lang=js"
export * from "./ModalAddEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__